import { Component, ChangeDetectionStrategy, computed, inject } from '@angular/core';
import { DmsBaseFolderAction } from '../dms-base-folder-action';
import { IrisDmsFoldersSandbox } from '@iris/common/modules/dms/sandbox/dms-folders.sandbox';
import { IrisConfirmationService } from '@iris/common/services/confirmation.service';
import { take, tap } from 'rxjs/operators';
import { NgClass } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuItem } from '@angular/material/menu';
import { StrakitButtonComponent } from '@ngx-strakit/cdk/controls';
import { StrakitButtonPrefixDirective } from '@ngx-strakit/cdk';

@Component({
  selector: 'iris-dms-remove-folder-button',
  templateUrl: './dms-remove-folder-button.component.html',
  styleUrls: ['./dms-remove-folder-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgClass,
    MatTooltipModule,
    MatMenuItem,
    StrakitButtonComponent,
    StrakitButtonPrefixDirective,
  ],
})
export class IrisDmsRemoveFolderButtonComponent extends DmsBaseFolderAction {
  private readonly dmsFoldersSandbox = inject(IrisDmsFoldersSandbox);
  private readonly confirmationService = inject(IrisConfirmationService);

  protected _label = 'label.dms.DeleteFolder';

  private readonly folder = computed(() => this.dmsFoldersSandbox.getFolderById(this.folderId())());

  public removeFolder(): void {
    const translateKey = this.folder()?.isSystem || this.folder()?.isTrashBin ? 'text.dms.SystemFolderRemoveConfirm' : 'text.dms.FolderRemoveConfirmNewDms';
    this.confirmationService.show$({
      message: this.translateService.instant(translateKey, { folderName: this.folder()?.name }),
      doNotEmitOnDismiss: true,
    }).pipe(
      take(1),
      tap(() => this.dmsFoldersSandbox.removeFolder(this.folderId())),
    ).subscribe();
  }
}
